import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { Nav, Tab } from "react-bootstrap";
import AttachmentFile from "../../asset/images/Vector.svg";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { IPO_Master } from "../../Configuration/API_URL";
import { toast } from "react-toastify";
import RoundLoader from "../../Components/Common/RoundRingLoader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";
import axiosInstance, { axiosFormDataInstance } from "../../CommonMethhods/axiosInstance";

function FamilyMaster() {
  const storeToken = localStorage.getItem("ssoToken");
  const [familyMasterDetail, setFamilyMasterDetail] = useState([]);
  const [mainError, setMainError] = useState(false);
  const [inputSearch, setInputSearch] = useState("");
  const [loader, setLoader] = useState({
    mainLoader: false,
    excelLoader: false,
    submitLoader: false,
  });

  const debouncedValue = useDebounce(inputSearch, 1000);
  
      useEffect(() => {
          handleOnChangeForSearchAp(debouncedValue);
      }, [debouncedValue]);

  const MAX_FILE_SIZE = 1048576 * 5; //100KB
  function isValidSize(fileName) {
    if (fileName && fileName.length > 0) {
      if (fileName[0].size <= MAX_FILE_SIZE) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const familyFormSchema = Yup.object().shape({
    inputFile: Yup.string(),
    fileUpload: Yup.mixed()
      .test(
        "Added Image",
        "*Mandatory to select File",
        (value) => value.length > 0
      )
      .test("is-valid-size", "*Please select file less than 5 MB", (value) => {
        return isValidSize(value);
      }),
  });

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    getValues,
    reset,

    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(familyFormSchema),
  });

  const handleFileUpload = (e) => {
    setValue("inputFile", getValues("fileUpload"));
    document.getElementById("uploadFile").value = e.target.value.replace(
      "C:\\fakepath\\",
      ""
    );
  };
  const FamilyDataUpload = async (data) => {
    try {
      const formData = new FormData();
      formData.append("fileData", data.fileUpload[0]);
      formData.append("type", "family");

      const familyData = await axiosFormDataInstance.post(
        IPO_Master.UploadIpoMaster_URL,
        formData,
      );
      const res = familyData?.data;
      if (res?.status === 0) {
        toast.success(res?.data);
        getFamilyMasterList("grid", "");
        clearErrors();
        reset();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    } finally {
      setLoader({ submitLoader: false });
    }
  };

  const OnFinalSubmit = (data) => {
    FamilyDataUpload(data);
  };

  const handleReset = () => {
    clearErrors();
    reset();
    document.getElementById("uploadFile").value = "";
  };

  const getFamilyMasterList = async (viewType = "grid", value = "") => {
    if (viewType === "grid") {
      setLoader({ mainLoader: true });
    }
    if (viewType === "excel") {
      setLoader({ excelLoader: true });
    }
    let payloadValue = { fileType: viewType, search: value, type: "family" };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getFamilyList = await axiosInstance.post(
        IPO_Master.GetMasterIpoData_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getFamilyList?.data);
      if (res?.status === 0) {
        setMainError(false);
        if (viewType === "grid") {
          setFamilyMasterDetail(res?.data?.fmlyList);
        } else if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setFamilyMasterDetail([]);
        if (viewType === "grid") {
          setMainError(res?.message);
        } else if (viewType === "excel") {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (viewType === "grid") {
        setMainError(error?.message);
        setFamilyMasterDetail([]);
      } else if (viewType === "excel") {
        toast.error(error?.message);
      }
    } finally {
      setLoader({
        mainLoader: false,
        excelLoader: false,
        submitLoader: false,
      });
    }
  };

  useEffect(() => {
    if (inputSearch === "") {
      getFamilyMasterList("grid", "");
    }
  }, [inputSearch]);

  const handleOnChangeForSearchAp = (data) => {
    // e.target.value = e.target.value.toUpperCase();
    // setInputSearch(e.target.value);
    if(data){
    getFamilyMasterList("grid", data);
    }
  };

  const handleDownloadClick = (e) => {
    getFamilyMasterList(e.target.value, inputSearch);
  };

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="familyIpo-master-wrapper">
        <form onSubmit={handleSubmit(OnFinalSubmit)}>
          <div className="card-box">
            <div className="row input-field-wrapper">
              <div className="col-md-3 col-sm-3 col-12">
                <div className="form-group">
                  <label className="form-label">Upload File</label>
                  <div className="custom-upload">
                    <input
                      id="uploadFile"
                      className="f-input"
                      readOnly
                      {...register("inputFile")}
                    />
                    <div className="fileUpload btn btn--browse">
                      <img src={AttachmentFile} alt="attachment" className />
                      <span>Browse File</span>
                      <input
                        type="file"
                        className="upload"
                        accept=".csv,.xlsx,.xlsm,.xlsb,.xltx,.xls"
                        {...register("fileUpload", {
                          onChange: (e) => {
                            handleFileUpload(e);
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="text-danger mt-2">
                    {errors?.fileUpload?.message}
                  </div>
                </div>
              </div>
            </div>
            <div className="save-reset-btn">
              <button type="submit" className="margin-save-btn">
                {loader.submitLoader ? (
                  <div className="download-loader">
                    <RoundLoader h={"20"} />
                  </div>
                ) : (
                  "Submit"
                )}
              </button>
              <button
                type="button"
                className="margin-reset-btn"
                onClick={handleReset}
              >
                Cancel
              </button>
            </div>
            <div>
              <div className="master-table-wrapper">
                <div className="tableHead">
                  <h4 className="master-title">Master Table</h4>
                  <button
                    type="button"
                    className="downloadBtn"
                    value="excel"
                    onClick={(e) => handleDownloadClick(e)}
                  >
                    {loader.excelLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"20"} />
                      </div>
                    ) : (
                      "Download"
                    )}
                  </button>
                </div>

                <div className="tab-content" id="myTabContent">
                  <Tab.Container
                    id="left-tabs-example"
                    activeKey="FamilyMaster"
                  >
                    {/* page tabs */}
                    <div className="d-flex justify-content-between mt-2">
                      <div className="d-flex">
                        <Nav variant="nav tabs page-tabs">
                          <li className="nav-item">
                            <Nav.Link eventKey="FamilyMaster">
                              Family Master
                            </Nav.Link>
                          </li>
                        </Nav>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          name="search-text"
                          id="SearchInput"
                          className="input-st mt-3 h-75"
                          placeholder="Search here..."
                          value={inputSearch}
                          autoComplete="off"
                          onChange={(e) => {
                            // handleOnChangeForSearchAp(e);
                            setInputSearch(e?.target?.value.toUpperCase())
                          }}
                          onInput={(e) => {
                            const start = e.target.selectionStart;
                            const end = e.target.selectionEnd;

                            let input = e.target.value.toUpperCase();
                            input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                    input = input.replace(/\s{2,}/g, " "); 
                                    input = input.replace(/^\s+/, ""); 

                            if (input.length > 100) input = input.slice(0, 100);
                            e.target.value = input;
                            e.target.setSelectionRange(start, end);
                            }}                          
                        />
                      </div>
                    </div>
                    {/* page tabs end */}

                    <div className="for-grid-section">
                      <Tab.Content>
                        <Tab.Pane eventKey="FamilyMaster">
                          <div
                            className="scroll-table family_table"
                            id="for-scroll-left"
                          >
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">S No</th>
                                  <th scope="col">Franchise Name</th>
                                  <th scope="col">Franchise code</th>
                                  <th scope="col">Region</th>
                                  <th scope="col">RMName</th>
                                  <th scope="col">FamilyCode</th>
                                  <th scope="col">Relationship</th>
                                </tr>
                              </thead>

                              <tbody>
                                {loader.mainLoader ? (
                                  <div className="loader-alignment">
                                    <Loader />
                                  </div>
                                ) : (
                                  familyMasterDetail &&
                                  familyMasterDetail?.map((value, item) => {
                                    let {
                                      sNo,
                                      franchiseName,
                                      franchiseCode,
                                      region,
                                      rmName,
                                      familyCode,
                                      relationship,
                                    } = value;
                                    return (
                                      <tr key={item}>
                                        <td>{sNo}</td>
                                        <td>{franchiseName}</td>
                                        <td>{franchiseCode}</td>
                                        <td>{region}</td>
                                        <td>{rmName}</td>
                                        <td>{familyCode}</td>
                                        <td>{relationship}</td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                            {mainError && (
                              <div className="report-error-message">
                                {noDataFound(mainError)}
                              </div>
                            )}
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </form>
      </main>
    </>
  );
}
export default FamilyMaster;
